import { render } from "./App.vue?vue&type=template&id=c662b6fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c662b6fa&lang=css"

import exportComponent from "C:\\Users\\weil\\Desktop\\bimbot\\repo\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__